module.exports = __webpack_public_path__ + "img/synaplus_logo_square_white.96bfcc80.svg";